import { getMazeStage, type MazeDirection, type MazeStageDefinition } from '@/flow/config/mazeStages';
import type { LearningProblem } from './learningTypes';

type StageSeed = {
  id: number;
  name: string;
  grid: string[];
  start: { x: number; y: number; dir: MazeDirection };
  goal?: { x: number; y: number };
};

const stage = ({ id, name, grid, start, goal }: StageSeed): MazeStageDefinition => ({
  id,
  name,
  grid,
  start,
  goal,
});

export const LEARNING_MAZE_STAGES: Record<string, MazeStageDefinition> = {
  'L2-1': stage({
    id: 201,
    name: '赤いゴールマスへ一歩',
    grid: ['.....', '.SG..', '.....'],
    start: { x: 1, y: 1, dir: 2 },
    goal: { x: 2, y: 1 },
  }),
  'L3-1': stage({
    id: 301,
    name: '動いてあいさつ',
    grid: ['.....', '.SG..', '.....'],
    start: { x: 1, y: 1, dir: 2 },
    goal: { x: 2, y: 1 },
  }),
  'L5-1': stage({
    id: 501,
    name: '右へ曲がる角',
    grid: ['.....', '.S...', '...G.', '.....'],
    start: { x: 1, y: 1, dir: 2 },
    goal: { x: 3, y: 2 },
  }),
  'L8-1': stage({
    id: 801,
    name: '壁までの距離を調べる',
    grid: ['.......', '.S#....', '.......', '.......'],
    start: { x: 1, y: 1, dir: 2 },
  }),
};

export const hasDedicatedLearningMaze = (problemId: string) => problemId in LEARNING_MAZE_STAGES;

export const getLearningMazeStage = (problem: LearningProblem): MazeStageDefinition => (
  LEARNING_MAZE_STAGES[problem.id] ?? getMazeStage(problem.stageId)
);